export default __webpack_public_path__ + "static/media/aarish.6f9ecf58.jpg";